import React from 'react';
interface Tab {
  id: string;
  label: string;
  count: number;
  color?: string;
}
interface TabNavProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}
export function TabNav({
  tabs,
  activeTab,
  onChange
}: TabNavProps) {
  return <div className="border-b border-slate-200 mb-6" data-id="element-32">
      <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs" data-id="element-33">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
                group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors
                ${isActive ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}
              `} aria-current={isActive ? 'page' : undefined} data-id="element-34">
              <span data-id="element-35">{tab.label}</span>
              <span className={`
                  ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium
                  ${isActive ? 'bg-blue-100 text-blue-600' : 'bg-slate-100 text-slate-600 group-hover:bg-slate-200'}
                `} data-id="element-36">
                {tab.count}
              </span>
            </button>;
      })}
      </nav>
    </div>;
}